module.exports = __webpack_public_path__ + "img/loading-image.3267a276.png";